/**
 * @generated SignedSource<<65dc0ebf763bbfeeac04b45f292c8470>>
 * @relayHash 0a59fed9dfa6599d230495f1a47dbc7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type AnnotationStateQuery$variables = {
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null | undefined> | null | undefined;
  pageId: string;
};
export type AnnotationStateQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly location: {
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly resolved: boolean;
          readonly resolvedUser: string | null | undefined;
        } | null | undefined;
        readonly type: string;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AnnotationStateQuery = {
  response: AnnotationStateQuery$data;
  variables: AnnotationStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ROOT"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1500
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "INLINE",
      "UNRESOLVED"
    ]
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "resolved"
        },
        {
          "kind": "ScalarField",
          "name": "resolvedUser"
        }
      ]
    }
  ],
  "type": "InlineComment"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AnnotationStateQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnnotationStateQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0a59fed9dfa6599d230495f1a47dbc7c",
    "id": "26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b",
    "metadata": {},
    "name": "AnnotationStateQuery",
    "operationKind": "query",
    "text": "query AnnotationStateQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:[INLINE,UNRESOLVED],depth:ROOT,first:1500){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,resolvedUser}}}}}}"
  }
};
})();

(node as any).hash = "40ea3762a17ce85bcac23a6ef83d3cbe";

export default node;
